<template>
  <b-modal
    :id="modalId"
    v-model="localIsActive"
    size="lg"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="onHide"
  >
    <template #modal-title>
      <h3 class="mb-0 text-white">Albergues</h3>
    </template>

    <shelters-table
      v-if="!showHelterForm"
      :crisis="opSecCrisis"
      :municipality-data="municipalityData"
      @add-shelter="addShelter()"
      @edit-shelter="editShelter"
      @refresh-shelters="$emit('refresh-shelters', municipalityData.id);"
    />

    <shelter-form
      v-else
      :shelter="shelter"
      @refresh-shelters="$emit('refresh-shelters', municipalityData.id);"
      @shelter-form-hide="shelterFormHide()"
    />

  </b-modal>
</template>

<script>
import axios from '@/libs/axios';
import { useToast } from "vue-toastification/composition";
import { computed,ref } from '@vue/composition-api';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ShelterForm from './ShelterForm.vue';
import SheltersTable from './SheltersTable.vue';
import { useFullscreenModalTransport } from './composables/useFullscreenModalTransport';

export default {
  props: {
    opSecCrisis: {
      type: Object
    },
    municipalityData: {
      type: Object
    },
    showModalShelters: {
      type: Boolean
    }
  },
  components: {
    ShelterForm,
    SheltersTable,
    ToastificationContent
  },
  setup(props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const modalId = computed(() => `crisis-shelters-${props.municipalityData?.id || 'modal'}`);

    const shelter = ref({
      id_operational_security_crisis: props.opSecCrisis.id,
      id_municipality: props.municipalityData.id,
      name: null,
      address:null,
      phone_1: null,
      phone_2: null
    });

    const showHelterForm = ref(false);

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showModalShelters;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    useFullscreenModalTransport(modalId, localIsActive);

    //METHODS
    const addShelter = () => {
      shelter.value.id_municipality = props.municipalityData.id;
      showHelterForm.value = true;
    }

    const cleanHelter = () => {
      shelter.value = {
        id_operational_security_crisis: props.opSecCrisis.id,
        id_municipality: props.municipalityData.id,
        name: null,
        address:null,
        phone_1: null,
        phone_2: null
      }
    }

    const editShelter = (shelterEdit) => {
      shelter.value = {
        ...shelterEdit,
        id_operational_security_crisis: props.opSecCrisis.id,
        id_municipality: props.municipalityData.id
      }

      showHelterForm.value = true;
    }

    const onHide = () => {
      showHelterForm.value = false;
      cleanHelter();
      emit('update:isActive', false);
    }

    const shelterFormHide = () => {
      showHelterForm.value = false;
      cleanHelter();
    }

    return {
      shelter,
      showHelterForm,

      localIsActive,
      modalId,

      addShelter,
      editShelter,
      onHide,
      shelterFormHide
    }
  }
}
</script>

<style scoped>

</style>
